<div class="d-flex align-items-center sub-3 text-muted input-height">
    {{ TAGS_NONE_SELECTED | translateTokenisedString }}
</div>
